export const labels = {
    close: 'Fechar',
    cancel: 'Cancelar',
    edit: 'Editar',
    free: 'Grátis',
    goToMenu: 'Ir para o cardápio',
    error404: {
        title: 'Opss, essa página está indisponível.',
        subtitle: 'A página que você está procurando não pode ser encontrada.',
        alt: 'Erro 404',
    },
    error500: {
        title: 'Opss, ocorreu um erro ao carregar esta página.',
        subtitle: 'Pedimos desculpas, nossa equipe de suporte já foi acionada e em breve este problema será resolvido!',
        alt: 'Erro 500',
    },
    coupon: 'Cupom',
    subtotal: 'Subtotal',
    discount: 'Desconto',
    referralCredits: 'Créditos usados',
    deliveryTax: 'Frete',
    total: 'Total',
    purchaseSummary: 'Resumo da compra',
};
//# sourceMappingURL=pt-labels.js.map